import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-800 bg-[#030710] mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center">
            <img
              src={COMPANY.logoUrl}
              alt="bekTech — Network & Cybersecurity Consulting"
              className="h-32 w-auto object-contain"
            />
          </div>
          <p className="text-slate-400 max-w-md mt-6 leading-relaxed text-sm">
            We design, secure, and operate enterprise networks for organizations of every size —
            building infrastructure that stays reliable when it matters most.
          </p>
        </div>

        <div>
          <div className="bek-eyebrow mb-4">Services</div>
          <ul className="space-y-3 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link
                  to="/services"
                  data-testid={`footer-link-${s.id}`}
                  className="text-slate-400 hover:text-slate-300 transition-colors"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="bek-eyebrow mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-slate-300 mt-0.5 shrink-0" />
              <a
                data-testid="footer-email"
                href={`mailto:${COMPANY.email}`}
                className="hover:text-slate-300 break-all"
              >
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-slate-300 mt-0.5 shrink-0" />
              <a data-testid="footer-phone" href={COMPANY.phoneHref} className="hover:text-slate-300">
                {COMPANY.phone}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800/80">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-slate-500 font-mono-tech tracking-widest uppercase">
            © {new Date().getFullYear()} bekTech — All Rights Reserved
          </div>
          <div className="text-xs text-slate-500 font-mono-tech tracking-widest uppercase">
            Secure · Reliable · Documented
          </div>
        </div>
      </div>
    </footer>
  );
}
